import {HStack} from 'platform/foundation';

import {FilterPresetButton, FilterPresetButtonProps} from './FilterPresetButton';
import {PresetDragHandle} from './PresetDragHandle';

/** Static look-alike of `SortableFilterPresetButton` for the drag overlay. */
export function FilterPresetButtonDragPreview(props: FilterPresetButtonProps) {
  return (
    <HStack align="center" minWidth={0} maxWidth="100%">
      <PresetDragHandle isGrabbing />
      <FilterPresetButton {...props} />
    </HStack>
  );
}
